import { render, staticRenderFns } from "./ZhanhuiCityStatBlock.vue?vue&type=template&id=7a31b0eb&scoped=true"
import script from "./ZhanhuiCityStatBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiCityStatBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhanhuiCityStatBlock.vue?vue&type=style&index=0&id=7a31b0eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a31b0eb",
  null
  
)

export default component.exports